import { render } from "./AppIcon.vue?vue&type=template&id=2a597dde"
import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\GuoRita\\OneDrive - MSFT\\git\\song-yo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__